// Helpers for the per-question date-range response filter (message:date).
//
// The period control stores the picked day as moment(localMidnight).toISOString(),
// i.e. an instant. Report date answers are stored as calendar dates (YYYY-MM-DD,
// no timezone), and the backend compares by calendar day. So we must send the
// CALENDAR day the user picked (local components), not a UTC instant — otherwise
// the day shifts by one for users not on UTC.

// Instant (Date/ISO) -> the local calendar day "YYYY-MM-DD" (the day the user
// actually selected in the picker).
export const toCalendarDate = (value) => {
  if (!value) return undefined;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return undefined;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// "YYYY-MM-DD" -> local-midnight ISO, so a round-trip through toCalendarDate
// yields the same calendar day on any timezone (used when hydrating from URL).
export const calendarDateToLocalIso = (str) => {
  if (!str) return undefined;
  const parts = String(str).split("-").map(Number);
  if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) return undefined;
  const [y, m, d] = parts;
  return new Date(y, m - 1, d).toISOString();
};
